import React, { FunctionComponent } from 'react';
import classnames from 'classnames';

import styles from './main.scss';

type ModalBodyProps = {
    className?: string;
    children?: React.ReactNode;
};

export const ModalBody: FunctionComponent<ModalBodyProps> = props => {
    const { className, children } = props;

    return (
        <div className={classnames(styles.modalBody, className)} data-tn="modal-body">
            {children}
        </div>
    );
};
